import type { MakeCall } from '../createMakeCall';
import { QualificationRequirementDefault } from '../types/qualifications/QualificationRequirement';

const getQualificationRequirementsDefaults = (makeCall: MakeCall) => () =>
  makeCall<QualificationRequirementDefault>(
    'GET',
    `/api/v2/qualification/requirements/defaults`,
  );
export { getQualificationRequirementsDefaults };
